export enum MarquisCoat {
  NO_COAT,
  STRAIT_COAT
}